import { useMutation } from 'react-query';
import acumaticaService from '../services/acumatica.services';

export const useSaveAcumaticaSettings = () => {
  return useMutation((data) => acumaticaService.saveAcumaticaSettings(data));
};

export const useSaveAcumaticaTokens = () => {
  return useMutation((data) => acumaticaService.saveTokens(data));
};

export const useGenerateAcumaticaTokens = () => {
  return useMutation((data) => acumaticaService.generateTokens(data));
};
